import { Controller } from '@hotwired/stimulus'

// Modal dialog. Put `data-controller="modal"` on a wrapper, mark the backdrop
// overlay with `data-modal-target="backdrop"`, and open/close with
// `data-action="modal#open"` / `modal#close`. Pressing Escape or clicking the
// backdrop (not the dialog itself) also closes it.
export default class extends Controller {
  static targets = ['backdrop']
  static values = { reloadOnClose: { type: Boolean, default: false } }

  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)
  }

  disconnect() {
    this.close()
  }

  open() {
    this.backdropTarget.classList.remove('hidden')
    document.body.style.overflow = 'hidden'
    document.addEventListener('keydown', this.handleKeydown)

    // Move focus into the dialog for keyboard users.
    const focusable = this.backdropTarget.querySelector(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    )
    focusable?.focus()
  }

  close() {
    this.backdropTarget.classList.add('hidden')
    document.body.style.overflow = ''
    document.removeEventListener('keydown', this.handleKeydown)
    if (this.reloadOnCloseValue) window.location.reload()
  }

  closeOnBackdrop(event) {
    if (event.target === event.currentTarget) this.close()
  }

  handleKeydown(event) {
    if (event.key === 'Escape') this.close()
  }
}
